import { render, staticRenderFns } from "./trial-duration-explanation.vue?vue&type=template&id=2cc4c0a2&"
import script from "./trial-duration-explanation.vue?vue&type=script&lang=js&"
export * from "./trial-duration-explanation.vue?vue&type=script&lang=js&"
import style0 from "./trial-duration-explanation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports